"use client";

import { useSyncExternalStore } from "react";
import {
  readBrowserPreference,
  subscribeBrowserPreferences,
  writeBrowserPreference,
} from "../lib/browser-preference";

export function useBrowserPreference(key: string, defaultValue: boolean) {
  const value = useSyncExternalStore(
    subscribeBrowserPreferences,
    () => {
      const stored = readBrowserPreference(key);
      return stored === null ? defaultValue : stored === "true";
    },
    () => defaultValue,
  );
  return [
    value,
    (next: boolean) => writeBrowserPreference(key, String(next)),
  ] as const;
}
